export default function System() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-4xl font-black tracking-tight text-black">System Health</h1>
        <p className="text-gray-500 mt-2">Monitor platform performance and system status</p>
      </div>
      
      <div className="bg-white border border-gray-200 rounded-2xl p-12">
        <div className="text-center">
          <div className="w-16 h-16 bg-gray-100 rounded-2xl flex items-center justify-center mb-4 mx-auto">
            <svg className="w-8 h-8 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          <h2 className="text-xl font-black text-black mb-2">System Monitoring Coming Soon</h2>
          <p className="text-gray-500 max-w-md mx-auto">
            Real-time system health monitoring and performance metrics will be available here. This feature is currently under development.
          </p>
        </div>
      </div>
    </div>
  );
}
